/**
 * Hilfsfunktion zum Extrahieren der Upgrade-Symbole aus einem Booking-Objekt
 *
 * @param {Object} booking - Das Booking-Objekt
 * @returns {Array} - Array mit den entsprechenden Upgrade-Symbolen
 */
export const extractUpgradeSymbols = booking => {
  const upgradeSymbols = new Set();

  const addUpgradeSymbol = symbol => {
    if (!symbol || typeof symbol !== 'string') return;
    upgradeSymbols.add(symbol);
  };

  const normalizeSpecialUpgrade = raw => {
    if (!raw || typeof raw !== 'string') return null;

    switch (raw) {
      case 'iconCakeRed':
        return 'childBirthdayFull';
      case 'iconCakeOrange':
        return 'childBirthday';
      default:
        return raw;
    }
  };

  // Überprüfe selectedPackage
  if (booking.selectedPackage && booking.selectedPackage.name) {
    const packageName = booking.selectedPackage.name;

    if (packageName === 'Kindergeburtstag All-Inc') {
      addUpgradeSymbol('childBirthdayFull');
    } else if (packageName === 'Kindergeburtstag Basic') {
      addUpgradeSymbol('childBirthday');
    } else if (packageName === 'Junggesellen-Abschied') {
      addUpgradeSymbol('bachelorParty');
    } else if (packageName === 'Erwachsenengeburtstag') {
      addUpgradeSymbol('adultBirthday');
    }
  }

  // Check specialUpgrades/tags to ensure consistent symbols across entertainments
  if (booking.specialUpgrades) {
    const specialUpgrades = Array.isArray(booking.specialUpgrades)
      ? booking.specialUpgrades
      : [booking.specialUpgrades];
    specialUpgrades
      .map(normalizeSpecialUpgrade)
      .filter(Boolean)
      .forEach(addUpgradeSymbol);
  }

  if (Array.isArray(booking.tags)) {
    booking.tags
      .map(normalizeSpecialUpgrade)
      .filter(Boolean)
      .forEach(addUpgradeSymbol);
  }

  // Überprüfe upsells
  if (booking.upsells && Array.isArray(booking.upsells)) {
    booking.upsells.forEach(upsell => {
      if (upsell.name === 'Wundertüte Geschenk') {
        addUpgradeSymbol('bag');
      } else if (upsell.name.includes('Pizzablech')) {
        addUpgradeSymbol('pizza');
      }
    });
  }

  // Prefer the more specific birthday icon over the generic one.
  // Example: tags might contain both "childBirthday" and "iconCakeRed".
  if (upgradeSymbols.has('childBirthdayFull')) {
    upgradeSymbols.delete('childBirthday');
  }

  return Array.from(upgradeSymbols);
};
